// @mui
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { Stack, Typography } from '@mui/material';
//
import Iconify from '../iconify/iconify';
import { ConfirmDialogProps } from './types';

// ----------------------------------------------------------------------

export default function ConfirmDialog({
  title,
  content,
  action,
  open,
  onClose,
  icon = 'solar:trash-bin-trash-bold',
  ...other
}: ConfirmDialogProps) {
  return (
    <Dialog
      fullWidth
      maxWidth="xs"
      open={open}
      onClose={onClose}
      {...other}
      PaperProps={{ sx: { borderRadius: '8px' } }}
    >
      <Iconify
        icon="material-symbols:close"
        onClick={onClose}
        sx={{
          position: 'absolute',
          top: 8,
          right: 8,
          cursor: 'pointer',
        }}
      />

      <DialogTitle sx={{ pb: 2 }}>{title}</DialogTitle>

      {content && (
        <DialogContent sx={{ typography: 'body2' }}>
          <Stack direction="column" alignItems="center" spacing={2}>
            <Iconify
              icon={icon}
              className="big-icon"
              sx={{ width: '75px', height: '75px', color: '#919EAB' }}
            />
            <Typography color="text.secondary" textAlign="center" width={215} variant="subtitle1">
              {content}
            </Typography>
          </Stack>
        </DialogContent>
      )}

      <DialogActions sx={{ justifyContent: 'center' }}>
        <Button variant="outlined" color="inherit" onClick={onClose}>
          Cancel
        </Button>

        {action}
      </DialogActions>
    </Dialog>
  );
}
